module.exports = __webpack_public_path__ + "fe6e42273d711029cb539b467972aeac.svg";